import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { authApi, errorMessage } from "@/lib/api";

const field = "mt-1.5 h-11 w-full rounded-xl border border-[#E5E0D8] bg-white px-3.5 outline-none focus:border-[#C59B27] focus:ring-4 focus:ring-[#C59B27]/15";
const empty = { current: "", next: "", confirm: "" };

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(empty);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 10) { setError("New password must be at least 10 characters"); return; }
    if (f.next !== f.confirm) { setError("New passwords do not match"); return; }
    setBusy(true);
    try {
      await authApi.changePassword({ current_password: f.current, new_password: f.next });
      toast.success("Password changed. Other devices have been signed out.");
      setF(empty);
      setOpen(false);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  const input = (k, label, ac) => (
    <label className="mt-4 block text-sm font-medium">{label}
      <input type="password" autoComplete={ac} required value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={field} data-testid={`change-password-${k}-input`} />
    </label>
  );

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setError(""); setF(empty); }}>
      <DialogTrigger asChild>
        <button aria-label="Change password" className="inline-flex h-10 items-center gap-2 rounded-full border border-[#E5E0D8] px-4 text-sm font-semibold" data-testid="change-password-btn">
          <KeyRound className="h-4 w-4" /> <span className="hidden sm:inline">Change password</span>
        </button>
      </DialogTrigger>
      <DialogContent className="w-[calc(100vw-2rem)] max-w-sm rounded-2xl bg-[#FDFBF7]" data-testid="change-password-dialog">
        <DialogTitle className="font-display text-2xl font-bold text-[#1B4332]">Change password</DialogTitle>
        <DialogDescription className="text-sm text-[#5B625D]">Use at least 10 characters. Other signed-in devices will be logged out.</DialogDescription>
        <form onSubmit={submit}>
          {input("current", "Current password", "current-password")}
          {input("next", "New password", "new-password")}
          {input("confirm", "Confirm new password", "new-password")}
          {error && <p className="mt-4 rounded-lg bg-[#F6E4E1] px-3 py-2 text-sm text-[#8A2B1E]" role="alert" data-testid="change-password-error">{error}</p>}
          <button disabled={busy} className="mt-6 h-11 w-full rounded-full bg-[#1B4332] font-semibold text-white disabled:opacity-60" data-testid="change-password-submit">
            {busy ? "Saving…" : "Update password"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
